export enum CalculationTypes {
    Fixed = 0,
    DynamicWithDefault = 1,
    DynamicWithZero = 2,
    DynamicWithError = 3
}
